import React, { useEffect, useState } from "react";
import "./Services.css";
import { Link } from "react-router-dom";

const ServicesSection = () => {
  const [apiData, setApiData] = useState([]);
  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  const cleanHTML = (text) => {
    if (!text) return "";

    return text
      .replace(/<(?!\/?(b|strong)\b)[^>]*>/gi, "") // keep <b>, <strong>
      .replace(/&nbsp;/g, " ");
  };

  const getCardConfig = (title, index) => {
    const iconMap = {
      "Gap Analysis": (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="37"
          viewBox="0 0 44 37"
          fill="none"
        >
          <path
            d="M16.2731 27.3684C11.725 27.3684 7.87619 26.0435 4.72672 23.3937C1.57724 20.7439 0.00167036 17.5074 1.32463e-06 13.6842C-0.00166771 9.86105 1.5739 6.62456 4.72672 3.97474C7.87953 1.32491 11.7283 0 16.2731 0C20.8179 0 24.6675 1.32491 27.822 3.97474C30.9765 6.62456 32.5512 9.86105 32.5462 13.6842C32.5462 15.2281 32.2542 16.6842 31.67 18.0526C31.0858 19.4211 30.293 20.6316 29.2916 21.6842L43.3115 33.4737C43.7705 33.8596 44 34.3509 44 34.9474C44 35.5439 43.7705 36.0351 43.3115 36.421C42.8525 36.807 42.2684 37 41.559 37C40.8497 37 40.2655 36.807 39.8065 36.421L25.7866 24.6316C24.5349 25.4737 23.0953 26.1403 21.468 26.6316C19.8407 27.1228 18.1091 27.3684 16.2731 27.3684ZM16.2731 23.1579C19.4026 23.1579 22.063 22.2372 24.2545 20.3958C26.4459 18.5544 27.5408 16.3172 27.5391 13.6842C27.5375 11.0512 26.4426 8.81474 24.2545 6.97474C22.0663 5.13474 19.4059 4.21333 16.2731 4.21053C13.1403 4.20772 10.4807 5.12912 8.29428 6.97474C6.10784 8.82035 5.01212 11.0568 5.00711 13.6842C5.00211 16.3116 6.09783 18.5488 8.29428 20.3958C10.4907 22.2428 13.1503 23.1635 16.2731 23.1579Z"
            fill="#0B82AD"
          />
        </svg>
      ),
      class: "service-card teal-card",

      "Internal Audit": (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="44"
          viewBox="0 0 44 44"
          fill="none"
        >
          <path
            d="M16.4189 7.29733H10.0337C9.79183 7.29733 9.55981 7.39344 9.38875 7.5645C9.21769 7.73556 9.12158 7.96758 9.12158 8.2095V39.2231C9.12158 39.4651 9.21769 39.6971 9.38875 39.8681C9.55981 40.0392 9.79183 40.1353 10.0337 40.1353H35.5744C35.8163 40.1353 36.0483 40.0392 36.2194 39.8681C36.3905 39.6971 36.4866 39.4651 36.4866 39.2231V8.2095C36.4866 7.96758 36.3905 7.73556 36.2194 7.5645C36.0483 7.39344 35.8163 7.29733 35.5744 7.29733H29.1892"
            stroke="white"
            stroke-width="2"
          />
          <path
            d="M16.4189 11.8582V7.29734H20.022C20.0341 7.29734 20.0457 7.29254 20.0543 7.28398C20.0628 7.27543 20.0676 7.26383 20.0676 7.25173V5.47301C20.0676 5.11365 20.1384 4.7578 20.2759 4.4258C20.4134 4.09379 20.615 3.79212 20.8691 3.53801C21.1232 3.28391 21.4249 3.08234 21.7569 2.94481C22.0889 2.80729 22.4447 2.73651 22.8041 2.73651C23.1635 2.73651 23.5193 2.80729 23.8513 2.94481C24.1833 3.08234 24.485 3.28391 24.7391 3.53801C24.9932 3.79212 25.1948 4.09379 25.3323 4.4258C25.4698 4.7578 25.5406 5.11365 25.5406 5.47301V7.25173C25.5406 7.27727 25.5607 7.29734 25.5862 7.29734H29.1893V11.8582C29.1893 12.1001 29.0932 12.3321 28.9221 12.5032C28.751 12.6742 28.519 12.7703 28.2771 12.7703H17.3311C17.0892 12.7703 16.8572 12.6742 16.6861 12.5032C16.515 12.3321 16.4189 12.1001 16.4189 11.8582Z"
            stroke="white"
            stroke-width="2"
          />
        </svg>
      ),
      class: "service-card1 white-card",

      "Customized Trainings": (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="38"
          height="38"
          viewBox="0 0 38 38"
          fill="none"
        >
          <g clip-path="url(#clip0_119_66)">
            <path
              d="M35.3947 29.9998C35.6927 29.7678 35.9303 29.4671 36.0872 29.1235C36.2441 28.7799 36.3157 28.4034 36.2959 28.0262C36.2761 27.649 36.1655 27.2821 35.9734 26.9568C35.7814 26.6315 35.5136 26.3574 35.1929 26.1578L35.1836 12.5019L32.838 14.0734V26.1531C32.5205 26.3523 32.2554 26.6246 32.0648 26.9473C31.8742 27.27 31.7638 27.6336 31.7426 28.0078C31.7215 28.382 31.7903 28.7558 31.9434 29.0979C32.0964 29.44 32.3292 29.7404 32.6222 29.974L31.7356 31.1515C30.947 32.1547 30.5102 33.3893 30.4924 34.6652V37.5315H32.404C32.8633 37.5314 33.3094 37.3782 33.6718 37.0962C34.0341 36.8141 34.2921 36.4192 34.4048 35.974L35.1812 32.8403V37.5315H37.5268V34.6933C37.5064 33.4113 37.0665 32.1714 36.2742 31.1632L35.3947 29.9998ZM18.7646 0L0 9.38228L18.7646 21.1101L37.5291 9.38228L18.7646 0Z"
              fill="#0B82AD"
            />
            <path
              d="M18.7645 23.4557L7.03662 15.645V19.6559C7.03662 21.7904 13.9326 28.1468 18.7645 28.1468C23.5963 28.1468 30.4923 21.7904 30.4923 19.6559V15.645L18.7645 23.4557Z"
              fill="#0B82AD"
            />
          </g>
          <defs>
            <clipPath id="clip0_119_66">
              <rect width="37.5291" height="37.5291" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      class: "service-card teal-card",

      "Transition of Standards": (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="40"
          height="40"
          viewBox="0 0 40 40"
          fill="none"
        >
          <g clip-path="url(#clip0_119_30)">
            <path
              d="M14.8553 28.4726C14.8553 27.6215 14.6941 26.822 14.3717 26.0741C14.0493 25.3262 13.6044 24.675 13.0371 24.1205C12.4697 23.566 11.812 23.1211 11.0641 22.7858C10.3162 22.4506 9.51666 22.2829 8.66558 22.2829C7.8145 22.2829 7.01499 22.4441 6.26707 22.7665C5.51915 23.0889 4.86149 23.5338 4.2941 24.1011C3.72671 24.6685 3.28183 25.3262 2.95945 26.0741C2.63707 26.822 2.47588 27.6215 2.47588 28.4726V29.7106H0V28.4726C0 27.6602 0.103162 26.8801 0.309485 26.1321C0.515808 25.3842 0.825293 24.675 1.23794 24.0044C1.65059 23.3339 2.1406 22.7278 2.70799 22.1862C3.27538 21.6446 3.92014 21.1804 4.64227 20.7935C3.94593 20.2003 3.41078 19.4976 3.03682 18.6852C2.66286 17.8728 2.47588 17.0088 2.47588 16.0932C2.47588 15.2421 2.63707 14.4426 2.95945 13.6947C3.28183 12.9468 3.72027 12.2956 4.27476 11.7411C4.82925 11.1866 5.48691 10.7417 6.24773 10.4064C7.00854 10.0712 7.8145 9.90352 8.66558 9.90352C9.51666 9.90352 10.3162 10.0647 11.0641 10.3871C11.812 10.7095 12.4632 11.1544 13.0177 11.7217C13.5722 12.2891 14.0171 12.9468 14.3524 13.6947C14.6876 14.4426 14.8553 15.2421 14.8553 16.0932C14.8553 16.9959 14.6683 17.8534 14.2943 18.6658C13.9204 19.4782 13.3852 20.1874 12.6889 20.7935C13.3981 21.1675 14.0364 21.6253 14.6038 22.1669C15.1712 22.7085 15.6612 23.3145 16.0739 23.9851C16.4865 24.6556 16.796 25.3649 17.0023 26.1128C17.2087 26.8607 17.3183 27.6473 17.3312 28.4726V29.7106H14.8553V28.4726ZM4.95176 16.0932C4.95176 16.609 5.04847 17.0926 5.2419 17.5439C5.43533 17.9953 5.69968 18.3886 6.03496 18.7238C6.37023 19.0591 6.76354 19.3235 7.21487 19.5169C7.6662 19.7103 8.14977 19.807 8.66558 19.807C9.18139 19.807 9.66496 19.7103 10.1163 19.5169C10.5676 19.3235 10.9609 19.0591 11.2962 18.7238C11.6315 18.3886 11.8958 17.9953 12.0893 17.5439C12.2827 17.0926 12.3794 16.609 12.3794 16.0932C12.3794 15.5774 12.2827 15.0938 12.0893 14.6425C11.8958 14.1912 11.6315 13.7979 11.2962 13.4626C10.9609 13.1273 10.5676 12.863 10.1163 12.6695C9.66496 12.4761 9.18139 12.3794 8.66558 12.3794C8.14977 12.3794 7.6662 12.4761 7.21487 12.6695C6.76354 12.863 6.37023 13.1273 6.03496 13.4626C5.69968 13.7979 5.43533 14.1912 5.2419 14.6425C5.04847 15.0938 4.95176 15.5774 4.95176 16.0932ZM34.9718 20.7935C35.681 21.1675 36.3194 21.6253 36.8867 22.1669C37.4541 22.7085 37.9441 23.3145 38.3568 23.9851C38.7694 24.6556 39.0789 25.3649 39.2852 26.1128C39.4916 26.8607 39.6012 27.6473 39.6141 28.4726V29.7106H37.1382V28.4726C37.1382 27.6215 36.977 26.822 36.6546 26.0741C36.3322 25.3262 35.8874 24.675 35.32 24.1205C34.7526 23.566 34.0949 23.1211 33.347 22.7858C32.5991 22.4506 31.7996 22.2829 30.9485 22.2829C30.0974 22.2829 29.2979 22.4441 28.55 22.7665C27.8021 23.0889 27.1444 23.5338 26.577 24.1011C26.0096 24.6685 25.5647 25.3262 25.2424 26.0741C24.92 26.822 24.7588 27.6215 24.7588 28.4726V29.7106H22.2829V28.4726C22.2829 27.6602 22.3861 26.8801 22.5924 26.1321C22.7987 25.3842 23.1082 24.675 23.5209 24.0044C23.9335 23.3339 24.4235 22.7278 24.9909 22.1862C25.5583 21.6446 26.2031 21.1804 26.9252 20.7935C26.2288 20.2003 25.6937 19.4976 25.3197 18.6852C24.9458 17.8728 24.7588 17.0088 24.7588 16.0932C24.7588 15.2421 24.92 14.4426 25.2424 13.6947C25.5647 12.9468 26.0032 12.2956 26.5577 11.7411C27.1122 11.1866 27.7698 10.7417 28.5306 10.4064C29.2915 10.0712 30.0974 9.90352 30.9485 9.90352C31.7996 9.90352 32.5991 10.0647 33.347 10.3871C34.0949 10.7095 34.7461 11.1544 35.3006 11.7217C35.8551 12.2891 36.3 12.9468 36.6353 13.6947C36.9706 14.4426 37.1382 15.2421 37.1382 16.0932C37.1382 16.9959 36.9512 17.8534 36.5773 18.6658C36.2033 19.4782 35.6681 20.1874 34.9718 20.7935ZM27.2347 16.0932C27.2347 16.609 27.3314 17.0926 27.5248 17.5439C27.7182 17.9953 27.9826 18.3886 28.3179 18.7238C28.6531 19.0591 29.0465 19.3235 29.4978 19.5169C29.9491 19.7103 30.4327 19.807 30.9485 19.807C31.4643 19.807 31.9479 19.7103 32.3992 19.5169C32.8505 19.3235 33.2438 19.0591 33.5791 18.7238C33.9144 18.3886 34.1787 17.9953 34.3722 17.5439C34.5656 17.0926 34.6623 16.609 34.6623 16.0932C34.6623 15.5774 34.5656 15.0938 34.3722 14.6425C34.1787 14.1912 33.9144 13.7979 33.5791 13.4626C33.2438 13.1273 32.8505 12.863 32.3992 12.6695C31.9479 12.4761 31.4643 12.3794 30.9485 12.3794C30.4327 12.3794 29.9491 12.4761 29.4978 12.6695C29.0465 12.863 28.6531 13.1273 28.3179 13.4626C27.9826 13.7979 27.7182 14.1912 27.5248 14.6425C27.3314 15.0938 27.2347 15.5774 27.2347 16.0932ZM22.2829 2.47588C21.2384 2.47588 20.2132 2.58549 19.2074 2.80471C18.2016 3.02393 17.228 3.33986 16.2866 3.75251C15.3453 4.16515 14.4555 4.66806 13.6173 5.26124C12.7792 5.85442 12.0054 6.54432 11.2962 7.33092L9.45863 5.66744C10.2839 4.76478 11.1866 3.96528 12.1666 3.26893C13.1467 2.57259 14.1783 1.97941 15.2615 1.4894C16.3447 0.999379 17.4795 0.631865 18.6658 0.386856C19.8522 0.141847 21.0579 0.0128952 22.2829 0C24.0496 0 25.7775 0.257904 27.4668 0.773712C29.1561 1.28952 30.7293 2.06968 32.1864 3.11419V0H34.6623V7.42764H27.2347V4.95176H30.5036C29.2786 4.13936 27.9697 3.52684 26.577 3.11419C25.1843 2.70155 23.753 2.48877 22.2829 2.47588ZM17.3312 37.1382C18.3757 37.1382 19.4008 37.0286 20.4067 36.8094C21.4125 36.5901 22.3861 36.2742 23.3274 35.8616C24.2688 35.4489 25.1585 34.946 25.9967 34.3528C26.8349 33.7597 27.6086 33.0698 28.3179 32.2831L30.1554 33.9466C29.3301 34.8493 28.4275 35.6488 27.4474 36.3451C26.4674 37.0415 25.4293 37.6347 24.3333 38.1247C23.2372 38.6147 22.1024 38.9822 20.9289 39.2272C19.7555 39.4722 18.5562 39.6012 17.3312 39.6141C15.5645 39.6141 13.8366 39.3562 12.1473 38.8404C10.458 38.3246 8.8848 37.5444 7.42764 36.4999V39.6141H4.95176V32.1864H12.3794V34.6623H9.11046C10.3355 35.4747 11.6444 36.0872 13.0371 36.4999C14.4297 36.9125 15.8611 37.1253 17.3312 37.1382Z"
              fill="#E6E6E6"
            />
          </g>
          <defs>
            <clipPath id="clip0_119_30">
              <rect width="39.6141" height="39.6141" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ),
      class: "service-card1 white-card",

      "Virtual Training": (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M28.4361 11.633H12.9255C11.2115 11.633 9.56767 12.3139 8.35567 13.5259C7.14366 14.7379 6.46277 16.3817 6.46277 18.0957V31.0212C6.46277 32.7353 7.14366 34.3791 8.35567 35.5911C9.56767 36.8031 11.2115 37.484 12.9255 37.484H28.4361C30.1502 37.484 31.794 36.8031 33.006 35.5911C34.218 34.3791 34.8989 32.7353 34.8989 31.0212V18.0957C34.8989 16.3817 34.218 14.7379 33.006 13.5259C31.794 12.3139 30.1502 11.633 28.4361 11.633ZM9.04787 18.0957C9.04787 17.0673 9.45641 16.081 10.1836 15.3538C10.9108 14.6266 11.8971 14.2181 12.9255 14.2181H28.4361C29.4646 14.2181 30.4509 14.6266 31.1781 15.3538C31.9053 16.081 32.3138 17.0673 32.3138 18.0957V31.0212C32.3138 32.0496 31.9053 33.0359 31.1781 33.7631C30.4509 34.4903 29.4646 34.8989 28.4361 34.8989H12.9255C11.8971 34.8989 10.9108 34.4903 10.1836 33.7631C9.45641 33.0359 9.04787 32.0496 9.04787 31.0212V18.0957Z"
            fill="#0B82AD"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M40.6584 14.4249L32.96 19.4322C32.7811 19.5482 32.6337 19.7066 32.5308 19.8933C32.428 20.08 32.3729 20.2893 32.3706 20.5024L32.3008 27.2547C32.2981 27.4725 32.3505 27.6873 32.4531 27.8794C32.5557 28.0715 32.7051 28.2345 32.8876 28.3534L40.6532 33.3995C40.8483 33.5266 41.0741 33.5987 41.3067 33.6081C41.5393 33.6175 41.7702 33.5639 41.9749 33.453C42.1796 33.342 42.3505 33.1779 42.4696 32.9778C42.5887 32.7777 42.6516 32.5492 42.6515 32.3164V15.5106C42.652 15.2776 42.5895 15.0487 42.4706 14.8483C42.3517 14.6478 42.1808 14.4833 41.976 14.372C41.7713 14.2608 41.5402 14.2069 41.3074 14.2162C41.0745 14.2255 40.8485 14.2976 40.6532 14.4249M40.069 29.9355L34.8962 26.5723L34.9505 21.2211L40.069 17.8941V29.9355Z"
            fill="#0B82AD"
          />
        </svg>
      ),
      class: "service-card teal-card",

      "Supplier Audit": (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="43"
          height="43"
          viewBox="0 0 43 43"
          fill="none"
        >
          <path
            d="M23.088 18.3891C24.161 16.8898 24.738 15.0924 24.738 13.2486C24.738 11.4049 24.161 9.60745 23.088 8.10817C24.0927 7.42371 25.2816 7.06029 26.4973 7.06594C28.137 7.06594 29.7096 7.71734 30.8691 8.87682C32.0286 10.0363 32.68 11.6089 32.68 13.2486C32.68 14.8884 32.0286 16.461 30.8691 17.6205C29.7096 18.78 28.137 19.4314 26.4973 19.4314C25.2816 19.437 24.0927 19.0736 23.088 18.3891ZM9.71566 13.2486C9.71566 12.0258 10.0783 10.8305 10.7576 9.81372C11.437 8.79698 12.4026 8.00453 13.5323 7.53658C14.6621 7.06862 15.9052 6.94618 17.1046 7.18474C18.3039 7.4233 19.4055 8.01215 20.2702 8.87682C21.1349 9.74148 21.7237 10.8431 21.9623 12.0425C22.2008 13.2418 22.0784 14.4849 21.6104 15.6147C21.1425 16.7444 20.35 17.71 19.3333 18.3894C18.3166 19.0687 17.1212 19.4314 15.8984 19.4314C14.2586 19.4314 12.686 18.78 11.5265 17.6205C10.3671 16.461 9.71566 14.8884 9.71566 13.2486ZM13.2486 13.2486C13.2486 13.7727 13.404 14.285 13.6952 14.7208C13.9864 15.1565 14.4002 15.4961 14.8844 15.6967C15.3685 15.8972 15.9013 15.9497 16.4153 15.8475C16.9293 15.7452 17.4014 15.4929 17.772 15.1223C18.1426 14.7517 18.3949 14.2796 18.4972 13.7656C18.5994 13.2516 18.5469 12.7188 18.3464 12.2346C18.1458 11.7505 17.8062 11.3366 17.3705 11.0455C16.9347 10.7543 16.4224 10.5989 15.8984 10.5989C15.1956 10.5989 14.5216 10.8781 14.0247 11.375C13.5278 11.8719 13.2486 12.5459 13.2486 13.2486ZM28.2638 30.0303V33.5632H3.53296V30.0303C3.53296 30.0303 3.53296 22.9643 15.8984 22.9643C28.2638 22.9643 28.2638 30.0303 28.2638 30.0303ZM24.7308 30.0303C24.4835 28.6524 22.3814 26.4973 15.8984 26.4973C9.41536 26.4973 7.18959 28.8114 7.06593 30.0303M28.1754 22.9643C29.2581 23.8065 30.1434 24.8754 30.769 26.0961C31.3946 27.3168 31.7454 28.6596 31.7967 30.0303V33.5632H38.8627V30.0303C38.8627 30.0303 38.8627 23.6179 28.1578 22.9643H28.1754Z"
            fill="#E6E6E6"
          />
        </svg>
      ),
      class: "service-card1 white-card",

      Documentation: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="27"
          viewBox="0 0 30 27"
          fill="none"
        >
          <path
            d="M29.903 7.11353V26.6757H9.20091V23.119H4.60046V19.5622H0V0H13.1365L17.7369 3.55677H25.3025V7.11353H29.903ZM13.8014 5.33515H16.7665L13.8014 3.0427V5.33515ZM18.4018 17.7838V7.11353H11.5011V1.77838H2.30023V17.7838H18.4018ZM23.0023 21.3406V5.33515H20.7021V19.5622H6.90069V21.3406H23.0023ZM27.6207 8.89191H25.3025V23.119H11.5011V24.8974H27.6207V8.89191Z"
            fill="#0B82AD"
          />
        </svg>
      ),
      class: "service-card teal-card",

      "Certificate Upgrades": (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="44"
          height="44"
          viewBox="0 0 24 24"
          fill="none"
        >
          <rect
            x="5"
            y="3"
            width="14"
            height="18"
            rx="2"
            stroke="#0B82AD"
            stroke-width="2"
          />

          <line
            x1="8"
            y1="7"
            x2="16"
            y2="7"
            stroke="#0B82AD"
            stroke-width="2"
          />

          <line
            x1="8"
            y1="11"
            x2="16"
            y2="11"
            stroke="#0B82AD"
            stroke-width="2"
          />
          <line
            x1="8"
            y1="14"
            x2="13"
            y2="14"
            stroke="#0B82AD"
            stroke-width="2"
          />

          <line
            x1="8"
            y1="18"
            x2="12"
            y2="18"
            stroke="#0B82AD"
            stroke-width="2"
          />

          <circle
            cx="16.5"
            cy="17.5"
            r="1.5"
            stroke="#0B82AD"
            stroke-width="2"
          />
        </svg>
      ),
    };

    const className =
      index % 2 === 0 ? "service-card teal-card" : "service-card1 white-card";

    return {
      icon: iconMap[title] || (
        <svg width="40" height="40">
          <circle cx="20" cy="20" r="18" fill="#0B82AD" />
        </svg>
      ),
      className,
    };
  };

  useEffect(() => {
    fetch(`${BASE_URL}Services/home`)
      .then((res) => res.json())
      .then((data) => setApiData(data.data || []))
      .catch(console.error);
  }, []);

  const createSlug = (title) => title?.toLowerCase().replace(/\s+/g, "-");

  return (
    <section className="services-section">
      <div className="section-header">
        <h2>Our Services</h2>
        <p>
          Comprehensive ISO consulting and training solutions tailored to your
          business needs
        </p>
      </div>

      <div className="slider-wrapper">
        <div className="services-slider">
          <div className="services-track">
            {[...apiData, ...apiData].map((item, i) => {
              const { icon, className } = getCardConfig(item.title, i);

              return (
                <Link
                  key={i}
                  to={`/service-details/${createSlug(item.title)}`}
                  className="service-item"
                >
                  <div className={className}>
                    <div className="icon-box">{icon}</div>

                    <h3>{item.title}</h3>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: cleanHTML((item.home_content || "No description available").slice(0, 80)),
                      }}
                    />
                    {/* <p>{(item.home_content || "No description available").slice(0, 80)}
                      {(item.home_content && item.home_content.length > 80) && "..."}</p> */}
                    {/* <p>{item.home_content || "No description available"}</p> */}
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
